import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  variant?: 'default' | 'glass' | 'outline';
}

export const Card = ({ children, className = '', variant = 'default', ...props }: CardProps) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'glass':
        return 'bg-white border border-slate-100 shadow-sm';
      case 'outline':
        return 'bg-transparent border border-slate-200 shadow-none';
      default:
        return 'bg-white border border-slate-100 shadow-sm';
    }
  };

  return (
    <div className={`rounded-md transition-all duration-300 ${getVariantStyles()} ${className}`} {...props}>
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '', ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`px-4 py-3 border-b border-slate-100 ${className}`} {...props}>
    {children}
  </div>
);

export const CardTitle = ({ children, className = '', ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h3 className={`sm:text-sm text-xs text-slate-900 tracking-tight ${className}`} {...props}>
    {children}
  </h3>
);

export const CardContent = ({ children, className = '', ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`p-4 sm:text-sm text-xs ${className}`} {...props}>
    {children}
  </div>
);

export const CardFooter = ({ children, className = '', ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`px-4 py-3 bg-slate-50/50 border-t border-slate-100 rounded-b-md ${className}`} {...props}>
    {children}
  </div>
);
